module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap3"
    }
  }, [_c('i', [_vm._v("Two")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWNSTAIRS THE TELEPHONE WAS")]), _vm._v(" ringing. Hebe let it ring, pealing its jarring note over and over again until at last it died. She lay looking forward to tomorrow and Silas, planning his holidays.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Trip desecrated the neighbour’s garden, making a neat little scrape, and, covering her excrement with tender paw, climbed back over the fence. It was raining. She leapt from the fence on to Hebe’s windowsill, dropped into the bedroom, padded across to the bed to insert herself under the quilt. Feeling wet fur against her face, Hebe put on her bedside light.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I shall never get to sleep.’ She fetched a towel and wiped the little animal who, purring, burrowed into the warmth. ‘Silas taught you that. You can snuggle up to him tomorrow.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For the third time the telephone rang. Irritated, she ran downstairs and picked up the receiver.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Yes?’ she said tersely.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You got big tits?’ A strong cockney accent.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I told you wrong number,’ she said irritably.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Vot colour knickers?’ pleaded the French voice.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You don’t even get the accent right.’ She put the instrument back and covered it with a cushion. She went back to bed where the cat made room for her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Midnight was striking from the town clock when she was disturbed yet again by a scrabbling at her window, a thud as feet hit the floor, the sound of material tearing.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Sod it! I’ve torn my skirt.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘God, Terry, I told you wrong number, I told you twice. Twice!’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Just look at my skirt.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Hebe switched on her bedside light. ‘Terry, I’m trying to sleep. Silas is coming home tomorrow.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Terry was examining the tear. ‘D’you think it will mend?’ he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Slender with cropped hair, wide shoulders and long legs. His skirt was pleated red cotton, worn with a fuchsia sweatshirt. ‘D’you think it will mend?’ he asked, stroking Hebe’s shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I shan’t mend it for you.’ She lay back, pulling the quilt up to her chin.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Listen to why I rang you. I made it with another girl, no trouble at all.’ Terry spoke excitedly. ‘It’s all due to you.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Couldn’t it have waited?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Listen—’ He was taking off the skirt and inserting himself into the bed. ‘What you got in here? Trip, it’s only me, don’t scratch. Bloody little beast, give over, make room. She’s wet.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Terry,’ she protested. ‘I told you—’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Listen, love.’ He put his arm round her, settling in the bed, stretching his legs.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Annoyed by the disturbance Trip scrabbled out of the bed and perched on the chair where Hebe had laid her clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Terry snuggled up to Hebe. ‘I haven’t come here to sleep with you.’ He kissed her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Sleep is just what one doesn’t do.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘It’s the crappiest expression for it. Give us a kiss.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Sleep is what I want at the moment.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Didn’t you hear what I said? I made it with another girl. No problem. You were right. No skirts. No knickers. I did like you taught. I came to thank you, thought you’d be glad to know.’ Terry was aggrieved.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I am glad. It’s just that I want to sleep. I told you it’s all in the mind, now will you—’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Okay, now listen to this:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("She can present joyes meaner than you do; Convenient and more proportional.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("So if I dream I have you, I—’")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("‘That’s Donne and the verse ends—“And sleep which locks up sense, doth lock all out.” That’s what I want now.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He laughed. ‘You are not really angry.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Are you in love with this girl?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘She was just a fun girl for an evening. I’ve got other ideas.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Someone specific?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Maybe.’ Terry leaned from the bed to pick up a book from the floor. ‘Could we read a bit? Would you read to me, for the last time?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘You read.’ She gave in.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Okay.’ Terry began reading. ‘I sing the progresse of a deathlesse soule—’ his young voice rising and falling in gentle cadence. Hebe remembered when she had first met him installing burglar alarms in the Midland Bank, noticed him reading Milton, started talking about poetry, an interest which had evolved into reading aloud to each other after lovemaking. He was taking a course in English at night school. She did not know what connection poetry had with women’s clothes. The skirts and knickers were a harmless aberration, the skirt, she suspected, a ploy to rouse her interest. Now it seemed this phase was ending. She had enjoyed the poetry, coming from a boy who looked as though he would be more at home in a disco than reading Donne to the cat, for I am not listening, thought Hebe, and Terry has read himself to sleep. She listened to his breathing, remembering his discovery of ‘’Tis the Arabian Bird alone lives chaste for ’tis but one, But had kind nature made them two they would as the doves and sparrows do.’ For a while he had called her his Arabian Bird. Perhaps that’s what I am, she thought. The town clock struck the half hour.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Have a heart, Terry.’ She shook him. ‘Wake up.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Terry woke staring at her, puzzled.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Time to go, Terry.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He was sleepy, his mind far away. Reluctantly he got out of bed. ‘Don’t happen to have any briefs?’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Silas’ would be too small.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Then I’ll go without. Lend us your jeans. I’ll see you get them back.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Are you sure you won’t need—’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Yes. I’ll leave my skirt with you as a memento, and the panties now, it’s okay without them.’ He had forgotten Donne.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I am glad.’ Hebe watched him struggle into the jeans she had taken off when she went to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Fit a bit tight, but what the hell. I’m—what am I?’ He stood looking down at Hebe, exultant.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Normal,’ she suggested, smiling up at him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘That’s about it.’ He searched in his skirt pocket. ‘This is for you.’ He thrust a wad of notes into Hebe’s hand. ‘You earned it. Can’t think how you did it. From now on I can be like anyone else.’ He bent down to kiss her. ‘’Bye, love.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Thanks, Terry.’ Hebe looked at the money. ‘It’s far too much.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No, it’s not. I’ve got this girl in mind. Don’t you want to know who she is?’ She could see he wanted to tell her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘No.’ He must manage on his own.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘She will be the first to get the straight treatment,’ he said, zipping up the jeans.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Without frills.’ She was amused.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He gave her a friendly hug. ‘Sending me up.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Go now. I must sleep.’ She pressed him to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘But I had to tell you. Analysts try and you did the trick in just two years.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Hebe was counting the money. ‘This is an awful lot, Terry.’ She was shocked by the amount.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I shan’t see you again, not like this. I want you to have it.’")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘Thanks.’ She did not trust herself to say more.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘I’ll take care of Trip when you go away. Keep in touch with you.’ He bent to kiss her again. ‘Goodbye now.’ He moved to the window to climb out. ‘This is a lot easier in jeans.’ He gave a snort of laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She heard him land in the flower bed, switched off her light and went to the window to watch him put on his shoes, climb the fence to the alleyway behind the gardens and break into a run, the sound of his feet beating a tattoo.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("‘There goes a satisfied customer,’ she said to the cat as she dropped the skirt and the discarded briefs into the waste-paper basket. ‘God! I must sleep.’ She got back into bed. She would miss Terry, miss the poetry reading. Buy herself a treat with part of his goodbye money, perhaps; put the rest towards Silas’ education. She felt a rush of affection for Terry. Will his new girl make him happy, will they read poetry together as we have? Why should I worry, she thought, as she lay listening to the cat purring. I taught him")]), _vm._v(" "), _c('p', {
    staticClass: "poem3",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("As freely as we met we’ll part")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("Each one possest of their own heart.")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("If he has learned that lesson why can’t I abide by it? We are friends. Restoration poems are not essential for survival, not essential for Silas. She dozed, thinking of the good times with Terry during the past years—quite a course in Eng. Lit., a profitable spell of work, a success. She remembered thinking him farouche until she had discovered his troubled spirit, grown fond of him for himself not only for the colour of his skin, which in some lights resembled a Mars Bar. So much for you. Briefly she permitted a vision of her grandfather, quickly banishing him from her mind.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Then she reproached herself for not making Terry promise to tell his new girl about his little ways. He would never tolerate briefs, never really change. The girl was on to a good thing if she did but know. Terry was intelligent and caring, which was more than could be said for most fee-paying lovers. The word ‘fees’ brought to mind Silas. Would the term away have changed him?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4a0829a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/7-chap3.vue
// module id = 78
// module chunks = 0